import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import { Img, Text } from "component";

import { colors, sizes } from "asset/constant";
import { _goToProfile } from "router/helper";
import { useRecoilValue } from "recoil";
import { authAtom } from "store";
import { css } from "style";

export default function DrawerHeader() {
  const auth = useRecoilValue(authAtom);

  return (
    <View>
      <TouchableOpacity activeOpacity={sizes.tapOpacity} onPress={_goToProfile}>
        <View style={styles.container}>
          <View style={styles.avatarContainer}>
            <Img style={styles.avatar} source={{ uri: auth?.user?.avatar }} />
          </View>

          <View style={styles.info}>
            <Text weight="extraBold">{auth?.user?.name}</Text>
            <View style={{ marginTop: 5 }}>
              <Text size={"xs"} weight="black">
                {auth?.user?.phone}
              </Text>
            </View>
          </View>
        </View>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: sizes.drawerW - 2 * sizes.space,
    height: 65,
    alignSelf: "center",
    alignItems: "center",
    paddingHorizontal: sizes.space,
    flexDirection: "row-reverse",
    borderRadius: sizes.radius.md,
    backgroundColor: colors.white,
    marginTop: sizes.space,
    ...css.shadowForWeb(5),
    marginBottom: 20,
  },

  avatarContainer: {
    width: 50,
    height: 50,
    overflow: "hidden",
  },

  avatar: {
    width: "100%",
    height: "100%",
    borderRadius: 100,
    borderWidth: 2,
    borderColor: colors.bg.light,
  },

  info: { flex: 1, marginRight: sizes.space / 2 },
});
